import Chip from 'material-ui/Chip'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'

interface Properties<Filter, FilterType> {
    readonly filterLabel: (filter: Filter) => string
    readonly filterToType: (filter: Filter) => FilterType
    readonly activeFilters: Filter[]
    readonly onDelete: (filterType: FilterType) => void
}

const styles = {
    root: {
        display: 'flex',
        order: 1,
        flexDirection: 'row-reverse',
        flexWrap: 'wrap',
        flex: 'auto',
    },
    chip: {
        margin: '8px !important',
    },
}

function activeFiltersViewConstructor<Filter, FilterType>() {
    return injectSheet<Properties<Filter, FilterType>>(styles)(
        ({classes, filterLabel, filterToType, activeFilters, onDelete}) => (
            <div className={classes.root}>
                {R.map(
                    filter =>
                        <Chip
                            className={classes.chip}
                            onRequestDelete={
                                () => onDelete(filterToType(filter))
                            }
                        >
                            {filterLabel(filter)}
                        </Chip>,
                    activeFilters,
                )}
            </div>
        )
    )
}

export const ActiveFiltersView = activeFiltersViewConstructor()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/Filtering/ActiveFiltersView.tsx